import type { ChangeEvent } from "react";
import { useState } from "react";

import "../styles/loginFormInput.css";
import { Button } from "./buttons/Button";
import Icon from "./Icon";

interface LoginFormInputProps {
  label: string;
  onChange: (data: string) => void;
  onSubmit?: () => void;
  initialValue?: string;
  password?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  tabIndex: number;
}
const LoginFormInput = (props: LoginFormInputProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  return (
    <div className={"loginFormInput"}>
      <label htmlFor={`${props.label}`}>{props.label}</label>
      <div>
        {/* input */}
        <input
          value={props.initialValue ?? ""}
          type={props.password && !showPassword ? "password" : "text"}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            props.onChange(e.currentTarget.value)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              props.onSubmit && props.onSubmit();
            }
          }}
          autoFocus={props.autoFocus}
          autoComplete={props.autoComplete}
          tabIndex={props.tabIndex}
        />
        {props.password && (
          <Button
            tabIndex={-1}
            onClick={(e) => e.preventDefault()}
            onMouseDown={() => setShowPassword(true)}
            onMouseUp={() => setShowPassword(false)}
            onTouchStart={() => setShowPassword(true)}
            onTouchEnd={() => setShowPassword(false)}
          >
            <Icon
              altText={"Show Password"}
              icon={showPassword ? "eye" : "eye-slash"}
            />
          </Button>
        )}
      </div>
    </div>
  );
};
export default LoginFormInput;
